import loadable from '@loadable/component';
import { routes as analyticsRoutes } from './analytics/routes';
import { routes as companiesRoutes } from './companies/routes';
import { routes as editorRoutes } from './editor/routes';
import { routes as ghostNewsRoutes } from './ghostnews/routes';
import { routes as ghostWriterRoutes } from './ghostwriter/routes';
import { routes as ingestionRoutes } from './ingestion/routes';
import { routes as myModuleRoutes } from './my-module/routes';
import { routes as projectsRoutes } from './projects/routes';
import { routes as roleRoutes } from './role/routes';
import { routes as settingsRoutes } from './settings/routes';
import { routes as subscriptionsRoutes } from './subscriptions/routes';
import { routes as userRoutes } from './user/routes';

const HomeLandingPage = loadable(() => import('./landing/page'));

export const routes = [
  {
    path: '',
    element: <HomeLandingPage />,
  },

  { path: 'analytics', children: analyticsRoutes },
  { path: 'editor', children: editorRoutes },
  { path: 'ingestion', children: ingestionRoutes },
  { path: 'subscriptions', children: subscriptionsRoutes },
  { path: 'projects', children: projectsRoutes },
  { path: 'my-module', children: myModuleRoutes },
  { path: 'user', children: userRoutes },
  { path: 'role', children: roleRoutes },
  { path: 'settings', children: settingsRoutes },
  { path: 'companies', children: companiesRoutes },
  { path: 'news-agents', children: ghostNewsRoutes },
  { path: 'ghost-writer', children: ghostWriterRoutes },
];
